import { FormTemplate } from '@src/core';

const Collect4Form: FormTemplate = {
  title: 'Questionário Puérpera',
  subtitle: 'Questionário 4: 3 meses após o parto',
  initialMessage:
    'Olá! Esperamos que você esteja bem! <br/><br/>  Chegamos a última etapa da nossa pesquisa! 🥳<br/><br/>  Antes de prosseguir, queremos expressar nossa sincera gratidão por sua participação até aqui. Sabemos que pedimos muito da sua atenção e paciência, e agradecemos imensamente por isso! 🤭<br/><br/>  Agora, estamos quase concluindo nossa jornada juntos. Para esta última fase, solicitamos gentilmente mais um pouco do seu tempo para responder às perguntas finais de nossa pesquisa.<br/><br/>  Como nas etapas anteriores, faremos novamente perguntas sobre seu processo de recuperação. Algumas perguntas podem parecer familiares, pois são essenciais para compreendermos sua evolução ao longo destes últimos <b>três meses</b>.<br/><br/>  Por favor, selecione as respostas que mais fielmente representam seu estado atual, especialmente em relação à recuperação na área com pontos onde você foi suturada.<br/><br/>  Durante as questões, você notará que mencionaremos a palavra "DOR" algumas vezes. Sempre que isso ocorre, estamos nos referindo a qualquer tipo de desconforto ou sensação incômoda associada aos pontos no períneo/vagina.<br/><br/>Vamos lá?',
  endedMessage:
    'Muito obrigado por ter respondido nossa pesquisa do projeto PEARLS! 🤩 <br/><br/>Sua ajuda faz toda a diferença para nós e para muitas outras mulheres.',
  step: {
    title: 'Avaliação',
    questions: {
      question01: {
        sequence: 1,
        type: 'radio',
        label: '1. Como você diria que está se sentindo fisicamente?',
        options: ['Muito Bem', 'Razoavelmente bem', 'Não muito bem', 'Nada bem'],
        validator: {
          dataType: 'string',
          required: true,
        },
        fullWidth: true,
      },

      question02: {
        sequence: 2,
        type: 'checkbox',
        label:
          '2. Nas últimas 24 horas, você precisou fazer uso de algum método para aliviar dor ou desconforto dos pontos?',
        helperText: '(marque todas as opções aplicáveis)',
        options: [
          'Precisei procurar ajuda em um hospital',
          'Utilizei métodos naturais que foram suficientes',
          'Utilizei analgésico que tenho em casa',
          'Não foi necessário uso de métodos para alívio da dor',
        ],
        validator: {
          dataType: 'array',
          required: true,
          min: { value: 1, errorMessage: 'Selecione pelo menos UMA opção' },
        },
        fullWidth: true,
      },

      question03: {
        sequence: 3,
        type: 'radio',
        label: '3. Se a dor ou desconforto da área onde você foi suturada/com pontos parou, quando isso ocorreu?',
        helperText: '(tente ser o mais precisa possível)',
        options: [
          'Nunca senti dor ou desconforto',
          'Na primeira semana após o nascimento do bebê',
          '2-4 semanas após o nascimento do seu bebê',
          '5-8 semanas após o nascimento do seu bebê',
          '9-12 semanas após o nascimento do seu bebê',
          'Ainda sinto dor ou desconforto',
        ],
        validator: {
          dataType: 'string',
          required: true,
        },
        fullWidth: true,
      },

      question04: {
        sequence: 4,
        type: 'radio',
        label: '4. Como você descreveria a intensidade da dor ou desconforto?',
        options: ['Nenhuma', 'Leve', 'Moderado', 'Grave'],
        validator: {
          dataType: 'string',
          required: true,
        },
        fullWidth: true,
      },

      question05: {
        sequence: 5,
        type: 'radio',
        label: '5. Se existe dor ou desconforto, qual a frequência?',
        options: ['Pouco frequente', 'Quase sempre', 'Sempre'],
        validator: {
          dataType: 'string',
          required: false,
        },
        fullWidth: true,
      },

      question06: {
        sequence: 6,
        type: 'radio-matrix',
        label:
          '6. Nas últimas 24 horas, quanta dor ou desconforto você sentiu na área onde foi suturada/com pontos ao fazer as seguintes atividades:',
        helperText: '',
        options: ['Nenhum', 'Leve', 'Moderado', 'Grave'],
        criteria: [
          'Alimentar seu bebê',
          'Andar certa de 100m',
          'Ficar em pé',
          'Sentar-se',
          'Deitada na cama',
          'Ao subir e descer da cama',
          'Ao se curvar ou abaixar',
          'Ao trocar o bebê',
          'Carregar seu bebê',
          'Fazer trabalho doméstico',
          'Ao urinar',
          'Ao evacuar',
        ],
        validator: {
          dataType: 'string',
          required: true,
        },
        fullWidth: true,
      },

      question07: {
        sequence: 7,
        type: 'checkbox',
        label: '7. Você:',
        helperText: '(marque todas as opções aplicáveis)',
        options: [
          'Olhou para o seu períneo/vagina usando um espelho',
          'Sentiu o períneo/vagina com a mão',
          'Pediu para um familiar olhar seu períneo/vagina',
          'Não olhou ou sentiu o períneo/vagina',
        ],
        validator: {
          dataType: 'array',
          required: true,
          min: { value: 1, errorMessage: 'Selecione pelo menos UMA opção' },
        },
        fullWidth: true,
      },

      question08: {
        sequence: 8,
        type: 'radio',
        label: '8. Depois de olhar a área onde você foi suturada/com pontos:',
        options: [
          'Parecia ou teve a sensação de estar MELHOR do que você pensava',
          'Parecia ou teve a sensação de estar PIOR do que você pensava',
          'Não conseguiu ver ou sentir',
        ],
        validator: {
          dataType: 'string',
          required: true,
        },
        fullWidth: true,
      },

      question09: {
        sequence: 9,
        type: 'radio',
        label: '9. Você acha que seu períneo/vagina está cicatrizando? Sente-se "de volta ao normal"?',
        options: [
          'Sinto que meu períneo/vagina está cicatrizado, está de volta ao normal',
          'Sinto que meu períneo/vagina está cicatrizando bem, está quase de volta ao normal',
          'Sinto que meu períneo/vagina cicatrizou, porém, ficou com menor elasticidade e não está de volta ao normal',
          'Sinto que meu períneo/vagina está cicatrizando muito mal, longe de voltar ao normal',
        ],
        validator: {
          dataType: 'string',
          required: true,
        },
        fullWidth: true,
      },

      question10: {
        sequence: 10,
        type: 'radio',
        label: '10. Você teve alguma infecção na área onde foi suturada/com pontos?',
        options: [
          'Sim, precisei ir ao hospital e eles refizeram os pontos',
          'Sim, a infecção foi confirmada por um exame com o cotonete passado no corte',
          'Acho que sim, utilizei métodos naturais em casa que foram suficientes',
          'Sim, fui ao hospital e precisei apenas utilizar antibiótico',
          'Não tive infecção',
        ],
        validator: {
          dataType: 'string',
          required: true,
        },
        fullWidth: true,
        requestDetail: {
          label:
            'Se a resposta foi "Sim, precisei ir ao hospital e eles refizeram os pontos", informe com quantos dias',
          conditions: [{ condition: 'Sim, precisei ir ao hospital e eles refizeram os pontos' }],
        },
      },

      question11: {
        sequence: 11,
        type: 'radio',
        label: '11. Algum ponto foi removido ou cortado da área onde você foi suturado?',
        options: [
          'Não, eles caíram sozinhos',
          'Sim, precisei ir até o serviço de saúde para retirar, pois estavam incomodando',
          'Sim, pedi para um familiar cortar',
        ],
        validator: {
          dataType: 'string',
          required: true,
        },
        fullWidth: true,
        requestDetail: {
          label: 'Se a resposta foi "Sim, ...", informe com quantos dias',
          conditions: [
            { condition: 'Sim, precisei ir até o serviço de saúde para retirar, pois estavam incomodando' },
            { condition: 'Sim, pedi para um familiar cortar' },
          ],
        },
      },

      question12: {
        sequence: 12,
        type: 'checkbox',
        label: '12. Você experimentou algum dos seguintes sintomas AO URINAR?',
        helperText: '(marque todas as opções aplicáveis)',
        options: [
          'Vazamento de urina ao tossir ou espirrar (incontinência de estresse)',
          'Urina com frequência durante o dia (mais de 7 vezes)',
          'Urina com frequência durante a noite (mais de 2 vezes)',
          'Não conseguiu esperar até chegar ao banheiro para urinar',
          'Ficou com incontinência urinária (sem saber que precisava urinar)',
          'Não sentiu nenhum desses sintomas desde o nascimento do seu bebê',
        ],
        validator: {
          dataType: 'array',
          required: true,
          min: { value: 1, errorMessage: 'Selecione pelo menos UMA opção' },
        },
        fullWidth: true,
      },

      question13: {
        sequence: 13,
        type: 'checkbox',
        label: '13. Você experimentou algum dos seguintes sintomas AO EVACUAR?',
        helperText: '(marque todas as opções aplicáveis)',
        options: [
          'Ciente de que precisa evacuar, mas incapaz de esperar até chegar ao banheiro',
          'Não sentiu vontade de evacuar, resultando em incontinência de fezes',
          'Presenciou sujeira ou manchas em sua roupa íntima com evacuações',
          'Sentiu dor ao evacuar',
          'Incapaz de controlar a eliminação de gases/pum pelo ânus',
          'Não experimentou nenhum sintoma',
        ],
        validator: {
          dataType: 'array',
          required: true,
          min: { value: 1, errorMessage: 'Selecione pelo menos UMA opção' },
        },
        fullWidth: true,
      },

      question14: {
        sequence: 14,
        type: 'radio',
        label: '14. Voltou a usar calças justas? Marque o grau de dor na região do períneo/vagina:',
        options: ['Nenhum', 'Leve', 'Moderado', 'Grave', 'Não tentei'],
        validator: {
          dataType: 'string',
          required: true,
        },
        fullWidth: true,
      },

      question15: {
        sequence: 15,
        type: 'radio',
        label: '15. Conseguiu retomar a atividade sexual sem dor à penetração?',
        options: [
          'Consegui, não senti dor',
          'Não realizei tentativa',
          'Tentei, porém, senti muita dor',
          'Consegui, porém, senti dor moderada',
          'Consegui, senti pouca dor',
        ],
        validator: {
          dataType: 'string',
          required: true,
        },
        fullWidth: true,
        requestDetail: {
          label: 'Se a resposta foi "Não realizei tentativa", descreva o motivo',
          conditions: [{ condition: 'Não realizei tentativa' }],
        },
      },

      question16: {
        sequence: 16,
        type: 'radio',
        label:
          '16. Se você tentou retomar atividade sexual, com quantas semanas após o nascimento do seu bebê você realizou a tentativa pela primeira vez?',
        options: [
          'Não realizei tentativa',
          'Dentro de 2 semanas após o nascimento do seu bebê',
          '3-4 (1 mês) semanas após o nascimento do seu bebê',
          '5-8 (2 meses) semanas após o nascimento do seu bebê',
          '9-12 (3 meses) semanas após o nascimento do seu bebê',
        ],
        validator: {
          dataType: 'string',
          required: false,
        },
        fullWidth: true,
      },

      question17: {
        sequence: 17,
        type: 'checkbox',
        label: '17. Você teve algum dos seguintes problemas quando tentou retomar a relação sexual pela primeira vez?',
        helperText: '(marque todas as opções aplicáveis)',
        options: [
          'Não realizei tentativa',
          'A área ao redor da cicatriz doeu quando esticada',
          'Área onde os pontos doeram',
          'Dor ou desconforto na penetração',
          'Não tive problemas',
          'Perda involuntária repentina de intestinos',
          'Perda involuntária repentina urina',
          'Vagina muito tensa / ou relaxada',
          'Vagina seca',
          'Vento na vagina',
          'Outro',
        ],
        validator: {
          dataType: 'array',
          required: true,
          min: { value: 1, errorMessage: 'Selecione pelo menos UMA opção' },
        },
        fullWidth: true,
        requestDetail: {
          label: 'Se a resposta foi "Outro", descreva',
          conditions: [{ condition: 'Outro' }],
        },
        isRequestDetailOther: true,
      },

      question18: {
        sequence: 18,
        type: 'checkbox',
        label: '18. Você continua tendo algum dos seguintes problemas durante a relação sexual?',
        helperText: '(marque todas as opções aplicáveis)',
        options: [
          'Não realizei tentativa',
          'A área ao redor da cicatriz doeu quando esticada',
          'Área onde os pontos doeram',
          'Dor ou desconforto na penetração',
          'Não tive problemas',
          'Perda involuntária repentina de intestinos',
          'Perda involuntária repentina urina',
          'Vagina muito tensa / ou relaxada',
          'Vagina seca',
          'Vento na vagina',
          'Outro',
        ],
        validator: {
          dataType: 'array',
          required: true,
          min: { value: 1, errorMessage: 'Selecione pelo menos UMA opção' },
        },
        fullWidth: true,
        requestDetail: {
          label: 'Se a resposta foi "Outro", descreva',
          conditions: [{ condition: 'Outro' }],
        },
        isRequestDetailOther: true,
      },

      question19: {
        sequence: 19,
        type: 'radio',
        label: '19. Após retomar as relações sexuais, como você classifica a relação?',
        options: ['Não realizei tentativa', 'Mais prazerosa', 'O mesmo que antes', 'Menos prazerosa'],
        validator: {
          dataType: 'string',
          required: true,
        },
        fullWidth: true,
      },

      question20: {
        sequence: 20,
        type: 'radio',
        label: '20. Se você NÃO tentou ter relações sexuais, qual foi o motivo?',
        helperText: '(marque todas as opções aplicáveis)',
        options: [
          'Falta de privacidade',
          'O bebê exige muita atenção',
          'O parceiro muito cansado',
          'O parceiro não está interessado',
          'O parceiro tem medo que pode ser doloroso para você',
          'Você está muito cansada',
          'Você está preocupada com a possibilidade de engravidar',
          'Você não está interessada',
          'Você não tem parceiro',
          'Você tem medo ou preocupação de que isso atrapalhe a cura',
          'Você tem medo que possa doer',
          'Outro',
        ],
        validator: {
          dataType: 'string',
          required: false,
        },
        fullWidth: true,
        requestDetail: {
          label: 'Se a resposta foi "Outro", descreva',
          conditions: [{ condition: 'Outro' }],
        },
        isRequestDetailOther: true,
      },
    },
  },
};

export { Collect4Form };
